const typography = {
  fontFamily: '"Asap", sans-serif',
  h1Large: {
    fontSize: 28,
    lineHeight: '38px',
    fontWeight: 500,
    '@media (min-width: 768px)': {
      fontSize: 48,
      lineHeight: '55px',
    },
  },
  h1: {
    fontSize: 28,
    lineHeight: '38px',
    fontWeight: 500,
    '@media (min-width: 768px)': {
      fontSize: 43,
      lineHeight: '55px',
    },
  },
  h2: {
    fontSize: 24,
    lineHeight: 1,
    fontWeight: 600,
    '@media (min-width: 768px)': {
      fontSize: 40,
      lineHeight: '45px',
    },
  },
  sectionLabel: {
    fontSize: 24,
    lineHeight: 1.5,
    fontWeight: 600,
    '@media (min-width: 768px)': {
      fontSize: 32,
    },
  },
  h3: {
    fontSize: 22,
    lineHeight: '30px',
    fontWeight: 500,
    '@media (min-width: 768px)': {
      fontSize: 30,
      lineHeight: '38px',
    },
  },
  h4: {
    fontSize: 20,
    lineHeight: '28px',
    fontWeight: 500,
    '@media (min-width: 768px)': {
      fontSize: 24,
      lineHeight: '32px',
    },
  },
  h4Bold: {
    fontSize: 20,
    lineHeight: '28px',
    fontWeight: 700,
    '@media (min-width: 768px)': {
      fontSize: 24,
      lineHeight: '32px',
    },
  },
  h5: {
    fontSize: 20,
    fontWeight: 500,
    lineHeight: '28px',
  },
  bigLabel: {
    fontSize: 20,
    lineHeight: '28px',
    fontWeight: 600,
    '@media (min-width: 768px)': {
      fontSize: 24,
      lineHeight: '32px',
    },
  },
  bigLabelUpper: {
    fontSize: 20,
    lineHeight: '28px',
    fontWeight: 600,
    textTransform: 'uppercase',
    '@media (min-width: 768px)': {
      fontSize: 24,
      lineHeight: '32px',
    },
  },
  // h6: {
  //   fontSize: '1.25rem',
  //   fontWeight: 500,
  //   lineHeight: 1.6,
  // },
  subtitle1: {
    fontSize: 20,
    lineHeight: '28px',
    fontWeight: 400,
    '@media (min-width: 768px)': {
      fontSize: 24,
      lineHeight: '32px',
    },
  },
  subtitle2: {
    fontSize: 18,
    fontWeight: 600,
    lineHeight: 1.25,
  },
  body: {
    fontSize: 18,
    lineHeight: 1.5,
    fontWeight: 400,
  },
  body1: {
    fontSize: 16,
    lineHeight: 2,
    fontWeight: 400,
  },
  body1Medium: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 500,
  },
  body1Semibold: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 600,
  },
  body2: {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.43,
  },
  labelBig: {
    fontSize: 16,
    lineHeight: '22px',
    fontWeight: 400,
  },
  label: {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 400,
  },
  labelMedium: {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 500,
  },
  labelSemibold: {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 600,
  },
  labelUpper: {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 400,
    textTransform: 'uppercase',
  },
  button: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '18px',
    textTransform: 'initial',
  },
  link: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '18px',
  },
  caption: {
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: 1.66,
  },
  overline: {
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: 2.66,
    textTransform: 'uppercase',
  },
}

export default typography